document.addEventListener('DOMContentLoaded', function () {
  // Target all forms with add-to-cart buttons
  const forms = document.querySelectorAll('form[action="/cart/add"]');

  forms.forEach(function (form) {
    form.addEventListener('submit', function () {
      // Delay a bit to let the cart update
      setTimeout(() => {
        const drawerTrigger = document.querySelector('.js-call-minicart');
        if (drawerTrigger) drawerTrigger.click();
      }, 500); // adjust if needed
    });
  });
});
